import {FlexBoxComponent, ReactButton, RichText} from '@gongxigames/framework/core/fragments/react';
import React, { useState} from 'react';
import {RowDirection} from '@gongxigames/framework/core';

type TextAndButtonProps = {
    textId: string;
    callback: Function;
    style: string;
    direction: RowDirection;
    maxHeight: number;
};

export function TextAndButtonAccept({textId, style, callback, direction, maxHeight}: TextAndButtonProps): JSX.Element {
    const [disabled, setDisabled] = useState(false);
    const onButtonClicked = () => {
        setDisabled(true);
        callback();
    };

    return (
        <FlexBoxComponent name='TextAndButtonAccept' alignItems={'center'} direction={direction} gap={20}>
            <RichText id={textId} style={style} maxHeight={maxHeight}/>
            <ReactButton
                disabled={disabled}
                name={'AcceptButton'}
                round={20}
                textStyleId={style}
                textId={'betPredictionAccept'}
                onClick={() => onButtonClicked()}
                backgroundColor={0x06b200}
                horizontalPadding={40}
                verticalPadding={20}
            />
        </FlexBoxComponent>
    );
}
